import {
  otmsHttp,
  bfsUserWebHttp,
} from '@/utils/http/index';
/**
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/cat_3121
 * 新增运力承运商
 */
export function addSupplier(params) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/register', params);
}

/**
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/cat_3121
 * 修改运力承运商
 */
export function editSupplier(params) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/upsert', params);
}

/**
 * http://otms-web-plus.hope-saas-plus.dev.yunlizhi.net/tcs_plus/pool/transport_supplier/statistic
 * 承运商数据统计
 */
export function fetchTransportSupplierStatistic() {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/statistic');
}

/**
 *http://otms-web-plus.hope-saas-plus.dev.yunlizhi.net/tcs_plus/pool/transport_supplier/detail
 * 承运商详情数据
 */
export function fetchTransportSupplierDetail(data) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/detail', data);
}

/**
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/cat_3121
 * 搜索承运商
 */
export function findSupplierList(data, query) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/search', data, {
    params: {
      ...query,
      sort: 'create_time__DESC',
    },
  });
}
/**
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/cat_3121
 * 承运商导出
 */
export function exportSupplier(params) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/export', params);
}

/**
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/cat_3121
 * 删除运力承运商
 */
export function deleteSupplier(params) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/delete', params);
}

/**
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/cat_3121
 * 运力承运商详情
 */
export function supplierDetail(params) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier/detail', params);
}
/**
 * https://yapi.ops.yunlizhi.cn/project/274/interface/api/9512
 * 信用码
 */
export function getByCreditCode(params) {
  return otmsHttp.post('/bfs_identity/enterprise/identity/get_by_credit_code', params);
}
/**
 * 获取省市区
 */
// export function fetchCityAreaTree() {
//   return noPrefixHttp.get('/city_area/tree');
// }
/**
 * 获取省市
 */
export function fetchProvinceCityAreaTree(params) {
  return otmsHttp.post('/base_plus/city_area/tree', params);
}
/**
 * 查询租户列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/8432
 */
export function getTenantList(params) {
  return bfsUserWebHttp.post(
    '/bfs_user/tenant/list', params,
  );
}
/**
 * 查询租户用户列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/209
 */
export function getTenantUserList(params) {
  return bfsUserWebHttp.post(
    '/bfs_user/tenant_user/list', params,
  );
}

// 承运商资源列表
export function getSupplierArchive(data, size, page) {
  return otmsHttp.post(`/tcs_plus/pool/transport_supplier_archive/page?size=${size}&page=${page}&sort=create_time__DESC`, data);
}
// 详情
export function detailSupplierArchive(data) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier_archive/detail', data);
}
// 关联承运商
export function createSupplierArchive(data) {
  return otmsHttp.post('/tcs_plus/pool/transport_supplier_archive/supplier_create', data);
}

// 运力报价分页
export function getQuotationPage(data) {
  return bfsUserWebHttp.post('/bfs_crm/manager/quotation/page', data);
}
// 运力报价详情
export function getQuotationDetail(data) {
  return bfsUserWebHttp.post('/bfs_crm/manager/quotation/detail', data);
}
// 分配任务
export function quotationAssign(data) {
  return bfsUserWebHttp.post('/bfs_crm/manager/quotation/assign', data);
}
// 保存跟进记录
export function quotationFollow(data) {
  return bfsUserWebHttp.post('/bfs_crm/manager/quotation/save_follow_info', data);
}
// 确认报价
export function quotationPrice(data) {
  return bfsUserWebHttp.post('/bfs_crm/manager/quotation/save_quotation', data);
}
// 驳回报价
export function quotationRefuse(data) {
  return bfsUserWebHttp.post('/bfs_crm/manager/quotation/reject', data);
}

/**
 * 认证审核分页
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/24355
 */
export function supplierAuditRecordPage(data, query) {
  return otmsHttp.post('/tcs_plus/pool/supplier/tenant/audit_record/page', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 认证审核
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/24359
 */
export function supplierAuditHandleAudi(data) {
  return otmsHttp.post('/pool/supplier/tenant/audit_record/handle_audit', data);
}

/**
 * 查询租户分页列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/6005
 */
export function tenantPage(data, query) {
  return bfsUserWebHttp.post('/bfs-user/tenant/page', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 认证审核信息详情
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/24357
 */
export function supplierAuditDetail(data) {
  return otmsHttp.post('/tcs_plus/pool/supplier/tenant/audit_record/detail', data);
}

// 绑定承运商
export function bindTenant(data) {
  return otmsHttp.post('/tcs_plus/transport_supplier/bind', data);
}
